import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Merge Tailwind classes with clsx.
 * @param inputs - The classes to merge.
 * @returns The merged classes.
 * @example
 * cn('text-red-500', 'bg-blue-500') // 'text-red-500 bg-blue-500'
 * cn('text-red-500', 'bg-blue-500', 'bg-green-500') // 'text-red-500 bg-green-500'
 */
export const cn = (...inputs) => twMerge(clsx(inputs));
